export default __webpack_public_path__ + "static/media/zombiewake.eb1db749.mp3";